var Connector = /** @class */ (function () {
    function Connector(charts) {
        this._charts = charts;
        this._showListeners = [];
        this._hiddenListeners = [];
        this.init();
    }
    Connector.prototype.init = function () {
        var _this = this;
        this._charts.forEach(function (currentChart, index) {
            var otherCharts = _this._charts.slice(0, index).concat(_this._charts.slice(index + 1));
            var handleTooltipShow = function (event) {
                otherCharts.forEach(function (otherChart) {
                    var otherPoints = [];
                    event.points.forEach(function (currentPoint) {
                        var _a;
                        var dataIndex = currentPoint.dataIndex, seriesIndex = currentPoint.seriesIndex;
                        var otherPoint = (_a = otherChart.getSeriesModel(seriesIndex)) === null || _a === void 0 ? void 0 : _a.getWrappedPoint(dataIndex);
                        if (otherPoint) {
                            otherPoints.push(otherPoint);
                        }
                    });
                    if (otherPoints.length > 0) {
                        var lastPoint = otherPoints[otherPoints.length - 1];
                        var otherTooltipParam = {
                            title: lastPoint.name,
                            mouse: { x: lastPoint.plotX, y: lastPoint.plotY },
                            points: otherPoints,
                        };
                        otherChart.getComponentModel('tooltip').showTooltip(otherTooltipParam, true);
                    }
                });
            };
            var handleTooltipHidden = function () {
                otherCharts.forEach(function (otherChart) {
                    otherChart.getComponentModel('tooltip').hideTooltip();
                });
            };
            _this._showListeners.push(handleTooltipShow);
            _this._hiddenListeners.push(handleTooltipHidden);
            currentChart.on('tooltip:show', handleTooltipShow);
            currentChart.on('tooltip:hidden', handleTooltipHidden);
        });
    };
    Connector.prototype.disconnect = function () {
        var _this = this;
        this._charts.forEach(function (currentChart, index) {
            currentChart.off('tooltip:show', _this._showListeners[index]);
            currentChart.off('tooltip:hidden', _this._hiddenListeners[index]);
        });
    };
    return Connector;
}());
export function connect(charts) {
    return new Connector(charts);
}
